// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-second-container {
  display: flex;
  gap: 40px;
  padding: 20px;
  background-color: #f9f9f9;
  font-family: Arial, sans-serif;
}

.about-second-left {
  flex: 1 1;
  padding: 20px;
}

.about-second-left h1 {
  font-size: 2rem;
  margin-bottom: 15px;
}

.about-second-left h2 {
  font-size: 1.5rem;
  margin-top: 20px;
  margin-bottom: 10px;
}

.about-second-left p {
  line-height: 1.6;
  color: #333;
}

.about-second-right {
  flex: 1 1;
  padding: 20px;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(10, 6, 6, 0.842);
}

.about-second-right h2 {
  font-size: 1.5rem;
  margin-bottom: 15px;
}

.about-second-right ul {
  list-style: none;
  padding: 0;
}

.about-second-right ul li {
  margin-bottom: 15px;
  line-height: 1.5;
}

.about-second-right ul li strong {
  color: #0073e6;
}

@media (max-width: 768px) {
  .about-second-container {
    flex-direction: column;
    gap: 20px;
    padding: 15px;
  }

  .about-second-left {
    padding: 10px;
    text-align: left;
  }

  .about-second-left h1 {
    font-size: 1.8rem;
    margin-bottom: 10px;
  }

  .about-second-left h2 {
    font-size: 1.4rem;
    margin-top: 15px;
    margin-bottom: 8px;
  }

  .about-second-left p {
    line-height: 1.5;
    font-size: 0.95rem;
    color: #333;
  }

  .about-second-right {
    padding: 10px;
    background-color: #fafafa;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    text-align: left;
  }

  .about-second-right h2 {
    font-size: 1.4rem;
    margin-bottom: 10px;
    text-align: center;
  }

  .about-second-right ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .about-second-right ul li {
    margin-bottom: 10px;
    line-height: 1.4;
    font-size: 0.9rem;
    text-align: left;
  }

  .about-second-right ul li strong {
    color: #090b0e;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MainAboutSecond/MainAboutSecond.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".about-second-container {\n  display: flex;\n  gap: 40px;\n  padding: 20px;\n  background-color: #f9f9f9;\n  font-family: Arial, sans-serif;\n}\n\n.about-second-left {\n  flex: 1;\n  padding: 20px;\n}\n\n.about-second-left h1 {\n  font-size: 2rem;\n  margin-bottom: 15px;\n}\n\n.about-second-left h2 {\n  font-size: 1.5rem;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.about-second-left p {\n  line-height: 1.6;\n  color: #333;\n}\n\n.about-second-right {\n  flex: 1;\n  padding: 20px;\n  background-color: #fafafa;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(10, 6, 6, 0.842);\n}\n\n.about-second-right h2 {\n  font-size: 1.5rem;\n  margin-bottom: 15px;\n}\n\n.about-second-right ul {\n  list-style: none;\n  padding: 0;\n}\n\n.about-second-right ul li {\n  margin-bottom: 15px;\n  line-height: 1.5;\n}\n\n.about-second-right ul li strong {\n  color: #0073e6;\n}\n\n@media (max-width: 768px) {\n  .about-second-container {\n    flex-direction: column;\n    gap: 20px;\n    padding: 15px;\n  }\n\n  .about-second-left {\n    padding: 10px;\n    text-align: left;\n  }\n\n  .about-second-left h1 {\n    font-size: 1.8rem;\n    margin-bottom: 10px;\n  }\n\n  .about-second-left h2 {\n    font-size: 1.4rem;\n    margin-top: 15px;\n    margin-bottom: 8px;\n  }\n\n  .about-second-left p {\n    line-height: 1.5;\n    font-size: 0.95rem;\n    color: #333;\n  }\n\n  .about-second-right {\n    padding: 10px;\n    background-color: #fafafa;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    text-align: left;\n  }\n\n  .about-second-right h2 {\n    font-size: 1.4rem;\n    margin-bottom: 10px;\n    text-align: center;\n  }\n\n  .about-second-right ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n  }\n\n  .about-second-right ul li {\n    margin-bottom: 10px;\n    line-height: 1.4;\n    font-size: 0.9rem;\n    text-align: left;\n  }\n\n  .about-second-right ul li strong {\n    color: #090b0e;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
